// SPDX-FileCopyrightText: © 2023 Schneider Electric
//
// SPDX-License-Identifier: LGPL-2.1-only

import type { ComponentInterface } from "@stencil/core";
import { Component, h, Host, Prop } from "@stencil/core";

@Component({
  tag: "qds-web-footer-media-item",
  shadow: true,
  styleUrl: "footer-media-item.css",
})
export class FooterMediaItem implements ComponentInterface {
  /**
   * The text for the title and the aria-label.
   *
   * @public
   * @type {string}
   */
  @Prop() public readonly description: string;

  /**
   * The href for the anchor.
   *
   * @public
   * @type {string}
   */
  @Prop() public readonly href: string;

  /**
   * The name of a registered icon library.
   *
   * @public
   * @type {string}
   * @default "default"
   */
  @Prop() public readonly iconLibrary?: string = "default";

  /**
   * The name of the icon to render.
   *
   * Available names depend on the icon library being used.
   *
   * @public
   * @type {string}
   */
  @Prop() public readonly iconName: string;

  /**
   * The language of the icon name.
   *
   * @public
   * @type {string}
   * @default "en"
   */
  @Prop() public readonly iconLang: string = "en";

  public render() {
    return (
      <Host role="listitem">
        <qds-button
          importance="subdued"
          href={this.href}
          target="_blank"
          title={this.description}
          text={this.description}
          rel="noreferrer"
          icon-name={this.iconName}
          icon-library={this.iconLibrary}
          lang={this.iconLang}
          icon-only
        />
      </Host>
    );
  }
}
